export default __webpack_public_path__ + "static/media/blueUpdateProfile.95551a70.svg";